let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8jW5F")).then(() => parcelRequire('aasCG'));